<template>
    <vue-phone-number-input
        @update="setPhone"
        v-model="phoneInput"
        :fetch-country="fetchCountry"
        :no-use-browser-locale="noUseBrowserLocale"
    ></vue-phone-number-input>
</template>

<script>
export default {
    name: "phone-number-field",
    props: {
        value: {
            type: String,
            required: true,
        },
        autoPickCountryCode: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        fetchCountry() {
            return false;
        },
        noUseBrowserLocale() {
            return !this.autoPickCountryCode;
        },
    },
    watch: {
        value: function (newValue) {
            this.$nextTick(function () {
                this.phoneInput = newValue;
            });
        },
    },
    data() {
        return {
            phoneInput: this.value,
        };
    },
    methods: {
        setPhone(data) {
            if (data.formatInternational) {
                this.$emit("input", data.formatInternational);
            }
        },
    },
};
</script>

<style lang="scss">
.input-tel__input {
    padding-left: 20px !important;
    border-bottom: 1px solid #fff !important;
}
.vue-phone-number-input {
    margin-top: 5px;
}
.dark-mode {
    .input-tel__input {
        color: #fff !important;

        &::placeholder {
            color: #77eec0;
            opacity: 1;
        }
    }
}
.input-tel__label {
    display: none !important;
}
</style>
